import { repeat } from 'lodash';
import {
  DEFAULT_SIGNATURE_LINE_LENGTH,
  DEFAULT_SIGNATURE_SPACE_LENGTH,
} from '../constants';

const generateSignatureLine = (
  lineLength: number = DEFAULT_SIGNATURE_LINE_LENGTH,
  spaceLength: number = DEFAULT_SIGNATURE_SPACE_LENGTH,
): string => {
  const space = repeat(' ', spaceLength);
  const line = repeat('_', lineLength);

  return `${space}${line}${space}`;
};

const defaultSignatureLine = generateSignatureLine();

const buildSignatureText = (
  text: string,
  signatureLine: string = defaultSignatureLine,
): string => `${text}${signatureLine}`;

export { generateSignatureLine, buildSignatureText };
